import axios from 'axios';
import { config } from '../../config';
import Cookies from 'js-cookie';

export default {
    namespaced: true, // ← IMPORTANTE: Activa el namespacing para este módulo
    state: {
        token: Cookies.get('token') || '',
    },
    getters: {
        isAuthenticated: state => !!state.token,
    },
    actions: {
        auth_logout({ commit }) {
            return new Promise((resolve) => {
                commit('RESET_STATE');
                Cookies.remove('token');
                resolve({ code: 200, message: 'Salida Exitosa!' });
            })
        },
        auth_login({ commit }, form) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/login', form)
                    .then(
                        response => {
                            console.log('response login: ',response);
                            if (response.status == 200) {
                                const accessToken = response.data.token;
                                console.log('accessToken',accessToken);
                                Cookies.set('token', accessToken);
                                commit('LOGIN_OK',response.data);
                                resolve(response);
                            } else {
                                commit('LOGIN_FAIL');
                                reject(response);
                            }
                        })
                    .catch(error => {
                        console.log(error);
                        commit('LOGIN_FAIL');
                        reject(error.response);
                    });
            })
        },
    },
    mutations: {
        LOGIN_OK(state, data) {
            state.token = data.token
        },
        RESET_STATE(state) {
            state.token = null;
            axios.interceptors.request.use(function (config) {
                const token = state.token;
                if (token) {
                    config.headers.Authorization = 'Bearer ' + token;
                } else {
                    delete config.headers.Authorization; // Si no hay token, elimina el header
                }
                //console.log('config.headers: ',config.headers);
                //console.log('token: ',token);
                config.headers.Accept = 'application/json';
                return config;
            }, error => Promise.reject(error));
            console.log('token2: ',state.token);
        },
        LOGIN_FAIL(state) {
            state.token = null;
        },
    }
}